module.exports = __webpack_public_path__ + "images/index/img09-9.3d02ebb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/kua/img09-9.jpg
// module id = p2xV
// module chunks = 21